import React from 'react'
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../assets/vacio.json";
import { display } from '@mui/system';
import { Typography } from '@mui/material';

export const VacioComponent = () => {
  return (
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            height:'100%',
            flex:1,
            alignItems:'center'
        }}
    >
        <Lottie
        style={{
            width:300
        }}
        animationData={groovyWalkAnimation}
        aria-aria-labelledby="use lottie animation"
        />
        <Typography
            style={{
                fontSize:30,
                fontWeight:'bold'
            }}
        >
            No se encontraron avances...
        </Typography>
    </div>
  )
}
